import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material';
import {FormGroup} from '@angular/forms';
import {FieldType} from '../../../models/field-type';
import {Validator} from '../../../models/validator.enum';
import {FormFactoryService} from '../../../services/form-factory.service';
import {FormConfig} from '../../../models/form-config';
import {SendCalculationEmailService} from '../../../../core/services/impl/send-calculation-email.service';
import {isMPay} from '../../../../core/utils/utils';
import {AssetsService} from '../../../services/assets.service';
import {Ga4EventsConfigService} from '../../../../core/services/ga4-events-config.service';
import {Ga4OffersElementKey} from '../../../../core/consts/ga4-offers-element-key.enum';

@Component({
    selector: 'app-send-calculation-dialog',
    templateUrl: './send-calculation-dialog.component.html',
    styleUrls: ['./send-calculation-dialog.component.scss']
})
export class SendCalculationDialogComponent implements OnInit {

  formConfig: FormConfig;
  bean: any;

  formGroup: FormGroup = new FormGroup({});
  formFactoryService: FormFactoryService;

  readonly EMAIL_CONTROL_KEY = 'email';

  get buttonIconPath(): string {
    if (isMPay()) {
      return `${this.assetsService.getIconsDirectoryPath()}/envelope.svg`;
    }
    return `${this.assetsService.ICONS_MAIN_DIR}/envelope.svg`;
  }

  constructor(private dialog: MatDialogRef<SendCalculationDialogComponent>,
              private assetsService: AssetsService,
              private ga4EventsService: Ga4EventsConfigService,
              private sendCalculationEmailService: SendCalculationEmailService) {
    this.createFormConfig();
  }

  ngOnInit() {
    this.sendCalculationEmailService.initEmail();
    this.initBean();
    this.buildForm();
    this.initControlChanges();
  }

  submitForm() {
    this.ga4EventsService.sendOffersElementEvent(Ga4OffersElementKey.SEND_CALCULATION_PROCEED);
    this.formFactoryService.submitForm();
    if (this.formFactoryService.isFormValid()) {
      this.sendCalculationEmailService.sendCalculationEmail()
          .then(() => console.log('OK'))
          .catch(err => console.log(err))
          .finally(() =>  this.close());

    }
  }

  close() {
    this.dialog.close();
  }

  private initBean(): void {
    this.bean = {
      email: this.sendCalculationEmailService.email
    };
  }

  private initControlChanges(): void {
    this.formGroup.controls[this.EMAIL_CONTROL_KEY].valueChanges.subscribe(value => this.sendCalculationEmailService.email = value);
  }

  private buildForm(): void {
    this.formFactoryService = new FormFactoryService(this.formConfig, this.bean);
    this.formFactoryService.buildFormGroup(this.formGroup);
  }

  private createFormConfig(): void {
    this.formConfig = {
      formKey: 'sendCalculationDialog',
      fieldsConfig: [{
        fieldKey: this.EMAIL_CONTROL_KEY,
        caption: 'SEND_CALCULATION_DIALOG_COMPONENT.email',
        type: FieldType.TextField,
        validators: [
            Validator.REQUIRED,
          {
            name: Validator.PATTERN_EMAIL,
            patternEmail: '^[a-z\\d]+[\\w\\d.-]*@(?:[a-z\\d]+[a-z\\d-]+\\.){1,5}[a-z]{2,6}$'
          },
          {
            name: Validator.MAX_LENGTH,
            maxLength: 250
          },
          {
            name: Validator.MIN_LENGTH,
            minLength: 5
          }
        ],
        autocomplete: 'email',
        properties: {
          textTransform: {
            type: 'lowercase'
          },
        }
      }]
    }
  }
}
